import { render } from "./ClassificationListView.vue?vue&type=template&id=107a3ddf&scoped=true&ts=true"
import script from "./ClassificationListView.vue?vue&type=script&lang=ts"
export * from "./ClassificationListView.vue?vue&type=script&lang=ts"

import "./ClassificationListView.vue?vue&type=style&index=0&id=107a3ddf&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107a3ddf"]])

export default __exports__